import request from '@/utils/axios'
import qs from 'qs'

/**
 * 获取课时账单列表
 * @param {*} username 
 * @param {*} params 
 */
export function getClassHourSpends(username, params) {
    // let postData = qs.stringify(params)
    return request({
        url: 'api/manager/classhourRecord/' + username,
        method: 'get',
        params: params
    })
}

export function getClassHourSpendsByDate(params) {
    let postData = qs.stringify(params)
    return request({
        url: 'api/manager/classhourRecord/getByDate',
        method: 'post',
        data: postData
    })
}
export function getClassHourSpendsByDateGet(params) {
    return request({
        url: 'api/manager/classhourRecord/getByDate',
        method: 'get',
        params: params
    })
}

/**
 * 添加课时账单
 * @param {*} params 
 */
export function addClassHourSpend(params) {
    // let postData = qs.stringify(params)
    return request({
        url: 'api/manager/classhourRecord',
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

/**
 * 修改课时账单
 * @param {*} params 
 */
export function editClassHourSpend(params) {
    let postData = qs.stringify(params)
    return request({
        url: 'api/manager/classhourRecord',
        method: 'put',
        data: postData,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

/**
 * 删除课时账单
 * @param {*} id 
 */
export function deleteClassHourSpend(params) {
    let data = qs.stringify(params);
    return request({
        url: 'api/manager/classhourRecord/delete',
        method: 'post',
        data: data
    })
}

/**
 * 删除课时账单 2022/6/23
 * @param {*} id 
 */
 export function deleteClasshourRecordById(params) {
    let data = qs.stringify(params);
    return request({
        url: 'api/manager/classhourRecord/deleteClasshourRecordById ',
        method: 'post',
        data: data
    })
}

/**
 * 会员课时转让
 * @param {*} params 
 * @returns 
 */
export function transferClassHour(params) {
    let data = qs.stringify(params);
    return request({
        url: 'api/manager/coursepackageandmember/classhoursTransfer',
        method: 'post',
        data: data
    })
}

/**
 * 获取会员课时转让记录
 * @param {*} params 
 * @returns 
 */
export function getClassHourTransferRecordByTelephoneNumber(params) {
    let data = qs.stringify(params);
    return request({
        url: 'api/manager/coursepackageandmember/getclasshoursTransferrecord',
        method: 'post',
        data: data
    })
}

/**
 * 导出会员的课时账单
 * @param {*} params 
 * @returns 
 */
export function excelDownloadClasshour(params) {
    let data = qs.stringify(params);
    return request({
        url: '/api/manager/file/excelDownloadClasshour',
        method: 'post',
        data: data,
        responseType: 'blob'
    })
}
/**
 * 导出学员最后一次约课时间
 * @param {*} params 
 * @returns 
 */
export function excelDownloadMemberLast(params){
    let postData = qs.stringify(params)
    return request({
      url: '/api/manager/file/excelDownloadMemberLast',
      method: 'post',
      data:postData,
      responseType: 'blob'
    })
}